import mixpanel from './mixpanel';
import sentry from './sentry';
import { identifyFromCookies } from './identifyUser';

const analyticsInit = () => {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  sentry.init(process.env.REACT_APP_SENTRY_URL);
  identifyFromCookies();
};

export { mixpanel, sentry };
export {
  identifyUserData,
  identifyFromCookies,
  resetAnalytics,
} from './identifyUser';
export type { UserData } from './identifyUser';
export default analyticsInit;
